/**
 * Wrappers for react-instantsearch-dom v6 connectors
 * These provide the same API as the v6 library but use v7 hooks internally
 */

export { connectStateResults } from './connectStateResults';
export { connectInfiniteHits } from './connectInfiniteHits';
export { connectRefinementList } from './connectRefinementList';
